<template>
  <div id="app"
  @click="preventClick">
    <router-view/>
  </div>
</template>

<script>
import { eventHubMixin } from '@/mixins/event';

export default {
  mixins: [eventHubMixin],
  methods: {
    preventClick() {
      this.eventHub.$emit('document:click');
    },
  },
};
</script>

<style lang="scss">
//
</style>
